export function hasUnclassifiedQuotation(quotation) {
  return Array.isArray(quotation && quotation.rows) && quotation.rows.some(row =>
    !row || ![1, 2].includes(Number(row.item_type))
  );
}
